module.exports = __webpack_public_path__ + "static/media/blob.d28d8e4c.png";